import { render, staticRenderFns } from "./ShareRoad.vue?vue&type=template&id=241cccb2&scoped=true&"
import script from "./ShareRoad.vue?vue&type=script&lang=js&"
export * from "./ShareRoad.vue?vue&type=script&lang=js&"
import style0 from "./ShareRoad.vue?vue&type=style&index=0&id=241cccb2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241cccb2",
  null
  
)

export default component.exports